import { Injectable } from 'angular-ts-decorators';

/**
 * # fileDownloader
 * Service to creat a download element for the client.
 * This gives us the ability to provide use cases like
 * generating a file using ajax and then starting the download for the client automatically
 */
@Injectable('fileDownloader')
export class FileDownloader {
  constructor(
    private $document: ng.IDocumentService,
    private $window: ng.IWindowService,
    private $q: ng.IQService,
  ) {
    'ngInject';
  }

  /**
   * Create an anchor element and push data into it for download
   * @param {string} name
   * The file name for the downloadable file
   * @param {string} data
   * the raw data to push into the downloadable element
   * @param {string} fileExtension
   * the file extension: xlsx, csv
   * @return {promise}
   * Promise for the data being fetched
   */
  createDownloadElement(
    name: string,
    data: string,
    fileExtension: string,
  ): ng.IPromise<any> {
    let deferred = this.$q.defer(),
      fileName = `${name}.${fileExtension}`,
      mimeType;

    if (fileExtension === 'xlsx') {
      mimeType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    } else if (fileExtension === 'csv') {
      mimeType = 'application/csv';
    } else if (fileExtension === 'pdf') {
      mimeType = 'application/pdf';
    } else {
      deferred.reject('Unsupported file extension');
      return deferred.promise;
    }

    let a = this.$document[0].createElement('a');
    this.$document[0].body.appendChild(a);
    let file = new Blob([data], { type: mimeType });

    a.href = URL.createObjectURL(file);

    a.download = fileName;
    a.click();

    deferred.resolve('Download successful');
    return deferred.promise;
  }
}
